/* eslint-disable radix */
import Axios from 'axios';
import { grandPaIdCommunity, parentIdProvince } from 'core/constants';
import { TYPES, PATH } from '../envs/core';
import { placesElastic } from '../constants/api';
import {
  ONDACERO,
  ANTENA3,
  LA_SEXTA,
  DEFAULT_SITE,
  sitesNotExcluded,
  getSite
} from '../constants/sites';
import { NAVIGATION_MODE } from '../constants';

import { getPlacesFromElastic } from '../dataProvider';

const a3 = 'https://www.antena3.com/noticias/elecciones/resultados/generales/';
const lasexta =
  'https://www.lasexta.com/noticias/nacional/elecciones-generales/resultados/';
const onda =
  'https://www.ondacero.es/noticias/elecciones-generales/resultados/';

const a3Val =
  'https://www.antena3.com/noticias/elecciones/resultados/valencianas/';
const lasextaVal =
  'https://www.lasexta.com/noticias/nacional/elecciones-comunidad-valenciana/resultados/';
const ondaVal =
  'https://www.ondacero.es/noticias/elecciones-valencia/resultados/';

export const getTitle = (pathType, pathYear, placeName) => {
  switch (pathType) {
    case TYPES.MUNICIPAL:
      return `ELECCIONES  MUNICIPALES DE ${placeName} ${pathYear}`;
    case TYPES.REGIONAL:
      // TODO Asumo que regional es valenciana hasta las siguientes elecciones
      // return `ELECCIONES  AUTONÓMICAS DE ${placeName} ${pathYear}`;
      return 'ELECCIONES VALENCIANAS';
    case TYPES.EUROPE:
      return `ELECCIONES  EUROPEAS ${pathYear}`;
    default:
      return `ELECCIONES GENERALES ${pathYear}`;
  }
};

const navigateByPlace = (place, host, year, type, numElection, val = false) => {
  const isAmp = window.parent.location.host.indexOf('amp') !== -1;
  let goTo = '';
  switch (host) {
    case 'antena3':
      goTo = `${val ? a3Val : a3}${year}/${type.toLowerCase()}/${numElection}/${
        place.ineId
      }${place.path}`;
      window.parent.location.href = isAmp ? goTo.replace('www.', 'amp.') : goTo;
      break;
    case 'lasexta':
      goTo = `${
        val ? lasextaVal : lasexta
      }${year}/${type.toLowerCase()}/${numElection}/${place.ineId}${
        place.path
      }`;
      window.parent.location.href = isAmp ? goTo.replace('www.', 'amp.') : goTo;
      break;
    case 'ondacero':
      goTo = `${
        val ? ondaVal : onda
      }${year}/${type.toLowerCase()}/${numElection}/${place.ineId}${
        place.path
      }`;
      window.parent.location.href = isAmp ? goTo.replace('www.', 'amp.') : goTo;
      break;
    default:
      break;
  }
};

export const refreshParent = (place, year, type, numElection, scopeChange) => {
  const host = window.location.hostname
    .replace(/www\./g, '')
    .replace(/amp\./g, '')
    .replace(/\.es/, '')
    .replace(/\.com/, '')
    .replace('localhost', 'antena3');
  if (typeof place === 'string') {
    Axios.get(`${PATH}${placesElastic}${place}`)
      .then(response => response.data)
      .then(data => {
        navigateByPlace(
          data,
          host,
          year,
          type,
          numElection,
          place === 'R10' && scopeChange
        );
      });
  } else {
    navigateByPlace(
      place,
      host,
      year,
      type,
      numElection,
      place === 'R10' && scopeChange
    );
  }
};

export const arrayToDict = (array, field = 'id') =>
  array.reduce((result, party) => {
    result[party[field]] = party;
    return result;
  }, {});

export const getRoute = (
  town,
  community,
  excludes,
  navigableMode,
  params,
  year,
  type
) => {
  if (parseInt(navigableMode) === 2) {
    return getStaticRoute(town, params);
  }
  return getNewsRoute(town, community, excludes, params, year, type);
};

export const getNewsRoute = (town, community, excludes, params, year, type) => {
  let locale = '';
  const site = getSite();
  if (town.path) {
    const path = town.path.split('/');
    locale =
      community && town.ineId !== parentIdProvince ? path.pop() : path[1];
  } else {
    locale = town.name;
  }
  let ineId =
    community && town.ineId !== parentIdProvince ? town.ineId : town.parentId;
  if (!ineId) {
    ineId = community;
  }

  // TODO: revisar cuando tengamos datos las comunidades con una provincia
  // TOOD Para el caso de comunidades con una provincia
  if (ineId === parentIdProvince) {
    ineId = grandPaIdCommunity;
  }

  if (
    !sitesNotExcluded.includes(site) &&
    excludes &&
    Boolean(excludes[ineId])
  ) {
    const excludeRoute = excludes[ineId];

    if (document.location.hash.indexOf('amp') === 1) {
      return excludeRoute.replace('www', 'amp');
    }

    return excludeRoute;
  }

  const { community: communityId } = getParams(town);

  let provinceLocale = '';
  if (town.path) {
    provinceLocale = town.path
      .split('/')
      .splice(2)
      .join('/');
  }

  const typePath = () => {
    if (type === TYPES.REGIONAL) {
      return params.sites[site].paths[type.toLowerCase()][communityId] || '';
    }
    if (type === TYPES.MUNICIPAL) {
      return params.sites[site].paths[type.toLowerCase()][communityId] || '';
    }
    return '';
  };

  const route = typePath(type)
    .replace('##year##', year)
    .replace('##locale##', locale)
    .replace('##ineId##', ineId)
    .replace('##provinceLocale##', provinceLocale);

  if (document.location.hash.indexOf('amp') === 1) {
    return route.replace('www', 'amp');
  }
  return route;
};

export const getStaticRoute = (town, params) => {
  const host = window.location.hostname.replace('localhost', 'ondacero.es');
  const { community: communityId } = getParams(town);

  // TODO LOGICA PARA DIFERENCIAR LAS URL POR TYPE
  //  province/town le quito lo ultimo
  // no se hace en a3

  let path = '';
  if (town.path) {
    path = town.path;
  }

  return setStaticUrl(host, communityId, path, params);
};

export const setStaticUrl = (host, communityId, path, params) => {
  const resultPath = `/${path
    .split('/')
    .slice(2)
    .join('/')}`;
  const site = getSite();
  if (params.sites[site].paths.static !== '') {
    let route = params.sites[site].paths.static;

    if (document.location.hash.indexOf('amp') === 1) {
      route = route.replace('www', 'amp');
    }

    if (resultPath !== '/') {
      return `${route}${resultPath}`;
    }
    return `${route}`;
  }
  return '';
};

export const navigateTo = (
  history,
  navigableMode,
  internalPath,
  item,
  community,
  excludes,
  params,
  year,
  type = 'REGIONAL'
) => {
  if (Number(navigableMode) === NAVIGATION_MODE.INTERNAL) {
    history.push(internalPath);
  } else if (Number(navigableMode) === NAVIGATION_MODE.EXTERNAL) {
    const path = getNewsRoute(item, community, excludes, params, year, type);
    window.parent.location.href = path;
  } else if (Number(navigableMode) === NAVIGATION_MODE.STATIC) {
    const pathPromise = () => {
      if (item.path) {
        return item;
      }
      const { community: communityId } = getParams(item);
      return getPlacesFromElastic(communityId);
    };
    Promise.resolve(pathPromise()).then(item => {
      const path = getStaticRoute(item, params);
      if (path) {
        window.parent.location.href = path;
      } else {
        history.push(internalPath);
      }
    });
  }
};

export const getParams = location => {
  if (location) {
    switch (location.typePlace) {
      case 'REGION':
        return { community: location.ineId };
      case 'PROVINCE':
        return { community: location.parentId, province: location.ineId };
      case 'TOWN':
        return {
          community: location.grandpaId,
          province: location.parentId,
          town: location.ineId
        };
      default:
        return { community: location.parentId };
    }
  } else {
    return {};
  }
};

const insularProvinces = [
  '35', // Las Palmas
  '38' // Santa Cruz de Tenerife
];

export const isInsular = province => insularProvinces.includes(province);

export * from './hooks';
